import { GitMerge, Waypoints, Cable, RadioTower, TowerControl, Antenna, Wrench, Siren, Network, ClipboardCheck } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { EXPERIENCE_AREAS } from "../../data/siteData";

const icons = {
  "git-merge": GitMerge,
  waypoints: Waypoints,
  cable: Cable,
  "radio-tower": RadioTower,
  "tower-control": TowerControl,
  antenna: Antenna,
  wrench: Wrench,
  siren: Siren,
  network: Network,
  "clipboard-check": ClipboardCheck,
};

export const IndustryExperience = () => (
  <section id="experience" className="section bg-[#050F22]" data-testid="experience-section">
    <div className="container-custom">
      <SectionHeading
        eyebrow="Industry Experience"
        title="Hands-On Telecommunications Capability"
        subtitle="The disciplines our team is qualified, accredited and experienced in delivering — from the fibre core to the tower top."
        center
      />

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
        {EXPERIENCE_AREAS.map((area, i) => {
          const Icon = icons[area.icon] || RadioTower;
          return (
            <Reveal key={area.title} delay={(i % 5) * 0.06}>
              <div
                className="group card-dark rounded-2xl p-6 flex flex-col items-center text-center gap-4 h-full"
                data-testid={`experience-area-${i}`}
              >
                <div className="w-14 h-14 rounded-xl flex items-center justify-center bg-[#00D4FF]/10 border border-[#00D4FF]/20 group-hover:bg-[#00D4FF] transition-colors duration-300">
                  <Icon className="w-7 h-7 text-[#00D4FF] group-hover:text-[#04121f] transition-colors duration-300" />
                </div>
                <h3 className="text-sm font-bold text-white leading-snug">{area.title}</h3>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
